module.exports = __webpack_public_path__ + "static/media/01-1-meeting-room.c39532f7.webp";